module.exports = __webpack_public_path__ + "img/arrowRight.e329cf6b.svg";